module.exports = ['$scope', '$routeParams', '$location', 'railsResource',
  function($scope, $routeParams, $location, $resource) {
    const PortfolioModel = $resource('/portfolio_models/:id', { id: '@id' },
      {
        sendLabels: { method: 'POST', url: '/portfolio_models/send_labels' },
        syncLabels: { method: 'PUT', url: '/portfolio_models/sync_labels' },
        getTranslationsUrl: { method: 'GET', url: '/portfolio_models/get_translations_url' },
      },
    );

    this.pmList = [];

    this.isSendLabelsPending = false;
    this.isSyncLabelsPending = false;

    PortfolioModel.getTranslationsUrl(result => {
      this.translationsUrl = result.url;
    });

    this.hasSelectedModelName = () => !!this.selectedModel.nameEn || !!this.selectedModel.nameFr;

    this.getPortfolioModels = () => {
      this.portfolioModels = PortfolioModel.query((result) => {
        result.map((pm) => {
          if (pm.category === 'null') { pm.category = 'other'; }
          this.pmList.push(pm.category);
          this.pmList = _.uniq(this.pmList);
        });
        const portfolioModelList = _.sortBy(result, 'risk');
        if (portfolioModelList instanceof Array) {
          this.selectedModel = portfolioModelList[0];
        }
        return portfolioModelList;
      });
    };

    this.getPortfolioModels();

    this.displayInOnboarding = () => {
      if ((this.selectedModel.displayInOnboarding = true)) {
        return this.selectedModel.displayInOnboarding = false;
      } else {
        return this.selectedModel.displayInOnboarding = true;
      }
    };

    this.filteredPortfolios = () => {
      if (this.selectedModel) {
        return this.selectedModel.portfolios;
      }
    };

    this.selectPortfolioModel = pm => {
      this.selectedModel = pm;
      if (this.newPortfolioModel && (pm !== this.newPortfolioModel)) {
        _.remove(this.portfolioModels, this.newPortfolioModel);
        this.newPortfolioModel = null;
      }
      return this.editSelectedModel = false;
    };

    this.createPortfolioModel = () => {
      if (this.newPortfolioModel) { return; }
      this.newPortfolioModel = { nameEn: 'New Portfolio Model', descriptionEn: '', risk: 3, category: null, displayInOnboarding: true };
      this.selectPortfolioModel(this.newPortfolioModel);
      this.portfolioModels.push(this.newPortfolioModel);
      this.selectPortfolioModel(this.newPortfolioModel);
      return this.editSelectedModel = true;
    };

    this.savePortfolioModel = () => {
      const after = model => {
        if (this.selectedModel.id == null) {
          _.assign(this.selectedModel, model);
        }
        this.newPortfolioModel = null;
        return this.editSelectedModel = false;
      };
      if (this.selectedModel.id != null) {
        return this.selectedModel.$update(after);
      } else {
        return PortfolioModel.create(this.selectedModel, after);
      }
    };

    this.deletePortfolioModel = function(model) {
      if (!confirm("Are you sure you want to delete this portfolio model?")) { return; }
      const after = () => {
        _.remove(this.portfolioModels, model);
        return this.selectPortfolioModel();
      };
      return model.$delete(after);
    };

    this.allocationTotal = assetAllocation => {
      return _.sumBy(assetAllocation, 'allocation');
    };

    this.allocationTotalValid = assetAllocation => {
      return Math.abs(this.allocationTotal(assetAllocation) - 1) < 0.0001;
    };

    this.sendLabels = () => {
      this.isSendLabelsPending = true;
      PortfolioModel.sendLabels(() => {
        this.isSendLabelsPending = false;
      });
    };

    this.syncLabels = () => {
      this.isSyncLabelsPending = true;
      PortfolioModel.syncLabels(() => {
        this.getPortfolioModels();
        this.isSyncLabelsPending = false;
      });
    };

    return this;
  }
];
